define(["require", "exports", "knockout", "jquery", "utility/throttle"], function (require, exports, ko, $, throttle_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Viewport = void 0;
    class Viewport {
        constructor() {
            this.WindowSize = ko.observable(window.innerWidth);
            this.ViewportLarge = ko.computed(() => {
                return this.WindowSize() >= 1200;
            });
            this.ViewportMedium = ko.computed(() => {
                return this.WindowSize() <= 1199 && this.WindowSize() >= 992;
            });
            this.ViewportSmall = ko.computed(() => {
                return this.WindowSize() <= 991 && this.WindowSize() >= 768;
            });
            this.ViewportXSmall = ko.computed(() => {
                return this.WindowSize() <= 767;
            });
            $(window).resize((0, throttle_1.default)(() => this.WindowSize(window.innerWidth), 40));
        }
    }
    exports.Viewport = Viewport;
    var viewport;
    exports.default = viewport;
});
//# sourceMappingURL=Viewport.js.map